// Weather Center place and barometer unit (WEB-7144); see src/action/weather-center-actions.js.
// Persisted. The place is cleared on logout so the next person on a shared browser doesn't
// inherit it; the barometer unit is a display preference and stays.

import { WEATHER_CENTER_SET_LOCATION, WEATHER_CENTER_SET_BAROMETER } from '../action/weather-center-actions'

const initialState = { location: null, barometer: 'inHg' }

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case WEATHER_CENTER_SET_LOCATION:
      return { ...state, location: payload }
    case WEATHER_CENTER_SET_BAROMETER:
      return { ...state, barometer: payload === 'mBar' ? 'mBar' : 'inHg' }
    case 'LOGOUT':
      return { ...initialState, barometer: state.barometer || 'inHg' }
    default:
      return state
  }
}
